import { Component, OnInit } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { AppService } from '../../app.service';
import { IntroductionService } from '../../services/introduction.service';
import { TeamMemberListComponent } from './team-member-list/team-member-list.component';
import { TypeTableComponent } from './type-table/type-table.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-team-teammembers',
  templateUrl: './team-teammembers.component.html',
  styleUrls: ['./team-teammembers.component.scss'],
  standalone: true,
  imports: [SafeHtmlPipe, TeamMemberListComponent, TypeTableComponent, CommonModule],
})
export class TeamMembersComponent implements OnInit {
  introduction: string = '';

  constructor(
    private introductionService: IntroductionService,
    private appService: AppService,
  ) {}

  ngOnInit() {
    if (!this.appService.isShowingEmptyState()) {
      this.introduction = this.introductionService.getContent('TypeTable');
    }
  }
}
